<template>
  <v-container fluid>
    <v-layout>
      <v-flex md12>
        <!-- Dialog for Add View Edit -->
        <action-dialog
          :type="dialogType"
          :title="title"
          :dialog="dialogStatus"
          @closeDialog="closeDialog"
          :loading="dialogLoading"
        >
          <v-container grid-list-xs>
            <v-layout>
              <v-flex md8 offset-md2>
                <v-card class="elevation-7">
                  <table
                    id="viewTable"
                    v-for="item in viewItems"
                    :key="item.id"
                  >
                    <tr>
                      <td class="propertyName">Merchant Code:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.merchant }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Device Serial:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.device_serial }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Branch:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.terminal }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">TRX #:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.transaction_no }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Date:</td>
                      <td
                        :class="[
                          'text-xs-center',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ $dateFormat(item.transaction_date, "YYYY-MM-DD") }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Time:</td>
                      <td
                        :class="[
                          'text-xs-center',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ $dateFormat(item.transaction_date, "HH:mm:ss") }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Trace No. (W):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.trace_no_wireless === null
                            ? "--"
                            : item.trace_no_wireless
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Card No. (W):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.card_no_wireless === null
                            ? "--"
                            : item.card_no_wireless
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Type (W):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.type_wireless === null
                            ? "--"
                            : item.type_wireless.toUpperCase()
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Amount (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.card_amount_wireless === null
                            ? "--"
                            : $amountInPeso(item.card_amount_wireless)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Trace No. (S):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.trace_no_sync === null
                            ? "--"
                            : item.trace_no_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Card No. (S):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.card_no_sync === null ? "--" : item.card_no_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Type (S):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.type_sync === null
                            ? "--"
                            : item.type_sync.toUpperCase()
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Amount (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.card_amount_sync === null
                            ? "--"
                            : $amountInPeso(item.card_amount_sync)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Discrepancy:</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.discrepancy === null
                            ? "--"
                            : $amountInPeso(item.discrepancy)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Cashier Name:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.cashier_name === null ? "--" : item.cashier_name
                        }}
                      </td>
                    </tr>
                  </table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </action-dialog>
        <table class="tableOverall">
          <tr>
            <th class="tableItemsTH">#</th>
            <th class="tableItemsTH">Action</th>
            <th class="tableItemsTH">
              <v-tooltip top>
                <span slot="activator">MC</span>
                <span>Merchant Code</span>
              </v-tooltip>
            </th>

            <th class="tableItemsTH">Device Serial</th>
            <th class="tableItemsTH">TRX #</th>
            <th class="tableItemsTH">Branch</th>
            <th class="tableItemsTH">Date</th>
            <th
              class="tableItemsTH"
              style="  cursor: pointer;"
              @click="toggleDate"
            >
              Time
              <v-icon style="font-size: 10px;">{{
                toggStatus ? "arrow_downward" : "arrow_upward"
              }}</v-icon>
            </th>
            <th class="tableItemsTH">Trace No. (W)</th>
            <th class="tableItemsTH">Card No. (W)</th>
            <th class="tableItemsTH">Type (W)</th>
            <th class="tableItemsTH" style="white-space: pre;">Amount (W)</th>
            <th class="tableItemsTH">Trace No. (S)</th>
            <th class="tableItemsTH">Card No. (S)</th>
            <th class="tableItemsTH">Type (S)</th>
            <th class="tableItemsTH" style="white-space: pre;">Amount (S)</th>
            <th class="tableItemsTH">Validation</th>
            <th class="tableItemsTH">Cashier Name</th>
          </tr>
          <tr class="tableTR" v-for="(item, index) in items" :key="item.key">
            <td
              :class="[
                'text-xs-center',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ index + 1 }}
            </td>
            <td
              :class="[
                'text-xs-center',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              <v-tooltip top>
                <a class="blue--text" slot="activator" @click="openDialog(item)"
                  >View</a
                >
                <span>View</span> </v-tooltip
              >&nbsp;
              <v-tooltip top>
                <a
                  class="teal--text"
                  slot="activator"
                  v-if="
                    $moduleAccess('align_transaction_report') &&
                      item.transaction_status === 3
                  "
                  @click="syncToWireless(item)"
                  >Align</a
                >
                <span>Align</span>
              </v-tooltip>
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.merchant }}
            </td>
            <td
              :class="[
                'text-xs-center',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.device_serial }}
            </td>

            <td
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.transaction_no }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="white-space: pre;"
            >
              {{ item.terminal }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="white-space: pre;"
            >
              {{ $dateFormat(item.transaction_date, "YYYY-MM-DD") }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="white-space: pre;"
            >
              {{ $dateFormat(item.transaction_date, "HH:mm:ss") }}
            </td>
            <td
              v-if="item.trace_no_wireless != null"
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.trace_no_wireless }}
            </td>
            <td
              v-if="item.trace_no_wireless === null"
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              N/A
            </td>
            <td
              v-if="item.card_no_wireless != null"
              :class="[
                'text-xs-right',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.card_no_wireless }}
            </td>
            <td
              v-if="item.card_no_wireless === null"
              :class="[
                'text-xs-right',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              N/A
            </td>
            <td
              v-if="item.type_wireless !== null"
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              <v-tooltip top>
                <span slot="activator">{{
                  item.type_wireless.length >= 7
                    ? item.type_wireless.substring(0, 7) + "..."
                    : item.type_wireless
                }}</span>
                <span>{{ item.type_wireless.toUpperCase() }}</span>
              </v-tooltip>
            </td>
            <td
              v-if="item.type_wireless === null"
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              N/A
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.card_amount_wireless === null
                  ? "N/A"
                  : $amountInPeso(item.card_amount_wireless)
              }}
            </td>

            <td
              v-if="item.trace_no_sync != null"
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.trace_no_sync }}
            </td>
            <td
              v-if="item.trace_no_sync === null"
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              N/A
            </td>
            <td
              v-if="item.card_no_sync != null"
              :class="[
                'text-xs-right',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.card_no_sync }}
            </td>
            <td
              v-if="item.card_no_sync === null"
              :class="[
                'text-xs-right',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              N/A
            </td>
            <td
              v-if="item.type_sync !== null"
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              <v-tooltip top>
                <span slot="activator">{{
                  item.type_sync.length >= 7
                    ? item.type_sync.substring(0, 7) + "..."
                    : item.type_sync
                }}</span>
                <span>{{ item.type_sync.toUpperCase() }}</span>
              </v-tooltip>
            </td>
            <td
              v-if="item.type_sync === null"
              :class="[
                'text-xs-center text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              N/A
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.card_amount_sync === null
                  ? "N/A"
                  : $amountInPeso(item.card_amount_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.discrepancy == null
                  ? "N/A"
                  : $amountInPeso(item.discrepancy)
              }}
            </td>
            <td
              :class="[
                'text-xs-left no-wrap',
                item.transaction_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.cashier_name == null ? "N/A" : item.cashier_name }}
            </td>
          </tr>
        </table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
var now = new Date();

export default {
  props: {
    items: Array,
    toggStatus: Boolean,
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      queryParams: {
        search: "",
        transaction_id: null,
        type: null,
      },
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      toggleStatus: false,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      viewItems: [],
      viewHeaders: [
        {
          text: "Merchant Code",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Device Serial",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Branch",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "TRX #",
          align: "center",
          value: "transaction_no",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Time",
          align: "center",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Trace No. (W)",
          align: "left",
          value: "trace_no",
          sortable: false,
        },
        {
          text: "Card No. (W)",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Type (W)",
          align: "left",
          value: "type",
          sortable: false,
        },
        {
          text: "Amount (W)",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Trace No. (S)",
          align: "left",
          value: "trace_no",
          sortable: false,
        },
        {
          text: "Card No. (S)",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Type (S)",
          align: "left",
          value: "type",
          sortable: false,
        },
        {
          text: "Amount (S)",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Discrepancy",
          align: "right",
          value: "amount",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    theData() {
      let theData = [];
      let aNewArray = [];

      this.items.forEach((item) => {
        aNewArray.push(item);
      });

      if (this.toggleStatus == true) {
        let dateASC = aNewArray.sort(function(a, b) {
          var dateA = new Date(a.transaction_date),
            dateB = new Date(b.transaction_date);
          return dateA - dateB;
        });

        dateASC.forEach((data) => {
          theData.push(data);
        });

        return theData;
      } else if (this.toggleStatus == false) {
        let dateDESC = aNewArray.sort(function(a, b) {
          var dateA = new Date(a.transaction_date),
            dateB = new Date(b.transaction_date);
          return dateB - dateA;
        });

        dateDESC.forEach((data) => {
          theData.push(data);
        });

        return theData;
      } else {
        return this.items;
      }
    },
  },
  methods: {
    sortByDate() {
      this.toggleStatus = !this.toggleStatus;
    },
    toggleDate() {
      this.$emit("toggleDate");
    },
    syncToWireless(data) {
      this.$emit("sync", data);
    },
    openDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewItems = [];

      this.viewItems.push(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    closeDialog() {
      this.dialogType = "";
      this.dialogStatus = false;
    },
  },
};
</script>

<style scoped>
.tableOverall {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  height: 95%;
  border: 3px solid #000000;
}

.tableItemsTH {
  border: 1px solid #000000;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
}

.tableItemsTD {
  border: 1px solid #000000;
  font-size: 8.5px;
  font-weight: bold;
}

.tableItemsTD2 {
  border: 1px solid #000000;
  color: red;
  font-size: 8.5px;
  font-weight: bolder;
}

.tableTR:hover {
  background-color: #ddd;
}

.theError {
  color: red;
  font-weight: bold;
}

#viewTable {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#viewTable td,
#viewTable th {
  border: 2px solid #000;
  padding: 8px;
}

.propertyName {
  background-color: rgb(241, 241, 241);
  font-weight: bold;
}
</style>
